export default {
  '@type': 'MerchantReturnPolicy',
  'applicableCountry': 'UK',
  'merchantReturnLink': 'https://www.timberland.co.uk/en-gb/customer-care/returns',
  'returnPolicyCategory': 'https://schema.org/MerchantReturnFiniteReturnWindow',
  'returnMethod': 'https://schema.org/ReturnByMail',
  'merchantReturnDays': 30
}
